import React, {useRef, useState} from 'react';

import Popup from "reactjs-popup";
import useScroll from "ubs-framework/v2/hooks/useScroll";
import * as Icon from "ubs-icons";
import {COLOR} from "ubs-framework/v2/common/constant";
import Select, {components} from "react-select";
import {isMobileDevice} from "ubs-framework/v2/common/function";

const MultiSelectFilter = React.memo((props) => {
    const popupRef = useRef(null)

    useScroll(document.getElementsByClassName('u_import-scroll')[0], (e) => {
        if (popupRef.current) popupRef.current.close()
    });

    /**
     * for skill filter
     * */
    const getSkillValue = (array1, array2) => {
        return array2?.length ? array1?.filter((o1) => array2.some((o2) => o1?._id === o2?.value || o1?._id === o2)) : undefined;
    };

    return (
        <React.Fragment>
            <Popup
                ref={popupRef}
                trigger={open => (
                    <div className="u_import-data-input">
                        <p className="u_small-font u_cp  u_flex u_align-center">
                            <div className="u_mr-10 u_flex u_flex-wrap" style={{width: '250px'}}>
                                {getSkillValue(props?.option, props?.errorTitle)?.length ? getSkillValue(props?.option, props?.errorTitle)?.map((data) => {
                                    return <span key={data?.value} className="u_mr-5 u_selected-skills">{data?.label}</span>
                                }) : props?.placeholder}
                            </div>
                            <Icon.DownArrow fill={COLOR.u_title} size={14}/>
                        </p>
                    </div>
                )}
                position="bottom center"
                closeOnDocumentClick
                closeOnEscape
                className="u_popover-container"
                arrow={false}
                contentStyle={{zIndex: 10001, maxWidth: '350px'}}
            >
                <Select
                    classNamePrefix="u_select"
                    className="u_input-select-inner u_multi-select-user u_menu-scroll"
                    placeholder=" "
                    options={props?.option}
                    isMulti={true}
                    menuPosition={!isMobileDevice() ? 'fixed' : ''}
                    maxMenuHeight={240}
                    value={props?.errorTitle ? getSkillValue(props?.option, props?.errorTitle) : ''}
                    onChange={e => props?.onChange(e)}
                    menuIsOpen={true}
                    isClearable={true}
                    noOptionsMessage={() => 'No requirement available'}
                    components={{
                        MultiValue: (props) => (
                            <components.MultiValue {...props}>
                                <p className="u_one-line u_task-darkname">{props?.data?.label}</p>
                            </components.MultiValue>
                        ),
                    }}
                />
            </Popup>
        </React.Fragment>
    );
});

export default MultiSelectFilter;
